import React from 'react';
import { Stack, Text, Banner, Table } from '@chaser/components';
import useOrganisation from '../../../../../../hooks/useOrganisation';
import useFetch from '../../../../../../hooks/useFetch';
import OrganisationService from '../../../../../../services/organisation-service';

const AuthCertificateDetails = () => {
  const { ShortCode, accessToken } = useOrganisation();
  const certificateId = accessToken.certificateId;

  const { data: certificate } = useFetch(OrganisationService.getAuthCertificateById, {
    certificateId,
    ShortCode,
  });

  const formatDate = date => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const columns = [
    {
      accessor: 'accountId',
      header: 'Account Id',
      cell: value => <Text color="Mid Neutral 1">{value || 'N/A'}</Text>,
    },
    {
      accessor: 'certificateId',
      header: 'Certificate Id',
      cell: value => <Text color="Mid Neutral 1">{value || 'N/A'}</Text>,
    },
    {
      accessor: 'createdAt',
      header: 'Created At',
      cell: value => <Text color="Mid Neutral 1">{formatDate(value)}</Text>,
    },
    {
      accessor: 'validUntil',
      header: 'Valid Until',
      cell: value => <Text color="Mid Neutral 1">{formatDate(value)}</Text>,
    },
    {
      accessor: 'isActive',
      header: 'Status',
      cell: value => (
        <Text color={value ? 'Green AA' : 'Red AA'}>{value ? 'Active' : 'Inactive'}</Text>
      ),
    },
  ];

  const data = [certificate];

  return (
    <Stack>
      <Stack gap="medium">
        <Text fontSize="heading.4" fontWeight="bold">
          Netsuite - OAuth 2.0 Client Credentials (M2M) Setup - Certificate Details
        </Text>

        <Table data={data} columns={columns} keyField="certificateId" />

        <Banner intent="info" showCloseButton={false}>
          You can find certificates on your NetSuite account:
          <Text as="span" fontWeight="bold">
            {' '}
            Setup - Setup Manager - Integration - OAuth 2.0 Client Credentials (M2M) Setup
          </Text>
        </Banner>
      </Stack>
    </Stack>
  );
};

export default AuthCertificateDetails;
